<template>
  <div id="app">
    <button v-if="isMobile" @click="toggleTabs" class="hamburgerBtn" ref="hamburger">
      <img alt="Hamburger menu" src="./assets/img/bars.svg">
    </button>
    <router-link to="/" class="logoSmMobile"><img alt="Supermileage logo" src="./assets/img/logo_csq.jpg"></router-link>
    <div class="tabs" ref="tabs" :class="{ 'open': menuOpen, 'userToggled': userToggled }">
      <nav class="nav nav-fill" style="align-items: center;">
        <router-link to="/" class="nav-link logoSm"><img alt="Supermileage logo" src="./assets/img/logo_csq.jpg"></router-link>
        <router-link to="/" class="nav-link tab" @click="linkClicked">{{ $t('home') }}</router-link>
        <router-link to="/results" class="nav-link tab" @click="linkClicked">{{ $t('results') }}</router-link>
        <router-link to="/results" class="nav-link tab" @click="linkClicked">{{ $t('teams') }}</router-link>
        <router-link to="/2024Edition" class="nav-link tab" @click="linkClicked">{{ $t('2024') }}</router-link>
        <router-link to="/results" class="nav-link tab" @click="linkClicked">{{ $t('sponsors') }}</router-link>
        <router-link to="/results" class="nav-link tab" @click="linkClicked">{{ $t('about') }}</router-link>
        <router-link to="/contact" class="nav-link tab" @click="linkClicked">{{ $t('contactUs') }}</router-link>
      </nav>
    </div> 
    <div class="border" style="width:60%; align-content: center; margin: 25px auto;"></div>
    <language />
    <div>
      <router-view></router-view>
    </div>
    
    <footer>
      <div class="border" style="width:60%; align-content: center; margin: 10px auto 30px auto;"></div>
      
      <div style="float: right;">
        <div class="footerLinks">
          <div class="icons">
            <a class="iconDiv" href="https://www.facebook.com/profile.php?id=100086277153575" target="_blank" rel="noopener noreferrer">
              <img class="icon" src="./assets/img/fb.png">
              <img class="iconHover" src="./assets/img/fb_hover.png">
            </a>
            <a class="iconDiv" href="https://www.instagram.com/qc_supermileage" target="_blank" rel="noopener noreferrer">
              <img class="icon" src="./assets/img/insta.png">
              <img class="iconHover" src="./assets/img/insta_hover.png">
            </a>
            <a class="iconDiv" href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" style="display: none;">
              <img class="icon" src="./assets/img/youtube.png">
              <img class="iconHover" src="./assets/img/youtube_hover.png">
            </a>
            <a class="iconDiv" href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" style="display: none;">
              <img class="icon" src="./assets/img/twitter.png">
              <img class="iconHover" src="./assets/img/twitter_hover.png">
            </a>
          </div>

          <div class="shamelessPlug">
            {{ $t('codedBy') }} <a href="https://ca.linkedin.com/in/philippe-landry-096925137">Don Felipe</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import language from './components/language.vue'

export default {
  name: 'App',
  components: {
    language,
  },
  data() {
    return {
      menuOpen: false, // State of the menu (open/closed)
      isMobile: window.innerWidth <= 1160,
      userToggled: false
    };
  },
  methods: {
    toggleTabs() {
      this.userToggled = true;
      this.menuOpen = !this.menuOpen;
    },
    checkWindowSize() {
      if (window.innerWidth <= 1160) {
        this.isMobile = true;
        this.menuOpen = false;
      } else {
        this.isMobile = false;
        this.menuOpen = true;
      }
      this.userToggled = false;
    },
    handleOutsideClick(event) {
      if (this.$refs.hamburger && this.$refs.tabs) {
        const isClickInsideMenu = this.$refs.tabs.contains(event.target);
        const isClickOnHamburgerButton = this.$refs.hamburger.contains(event.target);

        if (!isClickInsideMenu && !isClickOnHamburgerButton && this.menuOpen) {
          this.toggleTabs();
        }
      }
    },
    linkClicked() {
    if (this.isMobile && this.menuOpen) {
      this.toggleTabs();
    }
  }
  },
  mounted() {
    window.addEventListener('resize', this.checkWindowSize);
    this.checkWindowSize();
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkWindowSize);
    document.removeEventListener('click', this.handleOutsideClick);
  }
}
</script>

<style>
@font-face {
  font-family: Lato;
  src: url(./assets/fonts/Lato-Regular.ttf);
}

@font-face {
  font-family: Rubik;
  src: url(./assets/fonts/Rubik-Regular.ttf);
}

@font-face {
  font-family: Rubik semibold;
  src: url(./assets/fonts/Rubik-SemiBold.ttf);
}

@font-face {
  font-family: Rubik bold;
  src: url(./assets/fonts/Rubik-Bold.ttf);
}

body{
  font-size: 100%;
}
img{
  width: 100%;
}
footer{
  margin-top: 150px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 30px;
}
.hamburgerBtn {
  border: none;
  padding: 0;
  background: transparent;
  outline: none;
  cursor: pointer;

  display: none;
  position: fixed;
  width: 4%;
  margin: 8px 0 0 4%;
  z-index: 100;
}
.logoSmMobile{
  display: none;
}
.footerLinks{
  width:20%;
  float: right;
  margin-right: 5%;
}
.icons{
  display: flex;
  margin : 0 3% 20px 0;
  float: right;
}
.iconDiv{
  margin: 0 10px; /* Adjust the margin as needed for spacing between icons */
  position: relative;
  cursor: pointer;
}
.iconDiv img.iconHover{
  display: none;
}
.iconDiv:hover img.icon{
  display: none;
}
.iconDiv:hover img.iconHover{
  display: block;
}
.logoSm{
  width : 15%;
}
.tab{
  color: #5fbf00 !important;
  margin-top : 15px;
  font-family: Rubik semibold;
}
.tab:hover{
  color : #266e4e !important;
}
.tabs{
  padding-top : 10px;
  font-size : 1.5em;
  width: 90%;
  margin-left : 5%;
  transform: translateX(-100%);
  z-index: 99;
}
.tabs.open {
  transform: translateX(0);
}
.shamelessPlug{
  text-align: right;
  float: right;
  font-size: 0.8em;
  margin-right: 10%;
}

@media (max-width: 1160px) {
  .logoSm{
    display: none !important;
  }
  .logoSmMobile
  {
    display: block;
    width: 40%;
    margin-left: 30%;
    margin-top: 50px;
  }
  .hamburgerBtn {
    display: block;
  }
  .tabs {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    background-color: #fff;
    box-shadow: -2px 0 5px rgba(0,0,0,0.2);
    width: 45%; 
    margin-left: 0;
    transition: none;
    padding-top: 80px;
  }
  .tabs.userToggled {
    transition: transform 0.3s ease-in-out !important;
  }
  .tab{
    width: 100%;
  }
}

@media (max-width: 800px) {
  .hamburgerBtn{
    width: 6%;
  }
  .footerLinks{
    width: 30%;
  }
}
</style>